import React, {useContext} from 'react';
import {observer} from "mobx-react";
import * as Builder from "../../../builder";
import {TranslationDomainEnum} from "../../../types/enums";
import {TextType} from "../../../builder/form/type/TextType";
import {SubmitType} from "../../../builder/form/type/SubmitType";
import {ResetType} from "../../../builder/form/type/ResetType";
import {Translate} from "../../../components/util/translation.util";
import {StoreContext} from "../../../store.context";

export const FilterForm: React.FC<{
    onSubmit?: (values: any) => void,
    onReset?: () => void,
}> = observer(({ onSubmit, onReset }) => {
    const formReference = React.createRef() as any;
    const {
        appStore: {
            moduleStore: {
                userStore,
            },
        },
    } = useContext(StoreContext);

    return (
        <Builder.FilterForm
            ref={formReference}
            translationDomain={TranslationDomainEnum.USER_ADMINISTRATION}
            dirtyStateBlocker={false}
            collapsible={true}
            store={userStore}
            items={[
                {
                    title: <Translate message={`global.title.filter`} />,
                    position: 'left',
                    inputs: [
                        {
                            name: 'name',
                            label: 'user.field.name',
                            type: TextType,
                        },
                        {
                            name: 'username',
                            label: 'user.field.username',
                            type: TextType,
                        },
                        {
                            name: 'email',
                            label: 'user.field.email',
                            type: TextType,
                        },
                        {
                            label: 'global.button.filter',
                            type: SubmitType,
                            translationDomain: TranslationDomainEnum.MESSAGES
                        },
                        {
                            type: ResetType,
                            translationDomain: TranslationDomainEnum.MESSAGES,
                            onClick: () => {
                                formReference.current?.resetForm();
                                formReference.current?.submitForm()
                            }
                        }
                    ]}
            ]}

            onFinish={(values: any) => { onSubmit && onSubmit(values) }}
            initialValues={[]}
        />
    )
})